module.exports = __webpack_public_path__ + "static/img/shezhi.c26b971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/shezhi.png
// module id = 57
// module chunks = 123